<template>
    <div>
        <!-- note crossorigin="anonymous" is intented only for development and testing on production we need to remove it -->
        <video :class="getPlayerProgressbarClass"  :id="playerId" crossorigin="anonymous" ref="videoPlayer" class="video-js" :style="isUploadWindow?'width:600px;height:100%':''"></video>
    </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

import VideoPlayerMixin from '../../mixins/VideoPlayerMixin.js';
import {mapMutations, mapGetters} from "vuex"
import Utils from '../../components.utils.js';

export default {
    name: "VideoPlayer",
    mixins:[VideoPlayerMixin],
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        playerId: {
             type: String,
             default(){
                 return 'videoJSPlayer'
             }
        },

        isProgressbarRequired:{
             type: Boolean,
             default(){
                 return false;
             }
        },

        isCurrentTimeUpdateRequired:{
            type: Boolean,
             default(){
                 return false;
             }
        },

        frameRate:{
             type: Number,
             default(){
                 return 25;
             }
        },
        isUploadWindow:{
            type: Boolean,
            default(){
                return false;
            }
        }
    },
    data() {
        return {
            player: null,
            controller:{},
        }
    },
    methods:{
        getPlayerLiveDuration(){
           return this.$el.querySelector('video').duration;
        },
        updatePlayerCurrentTime(){
           let el = this.$el.querySelector('.vjs-control-bar .player-current-time-division .currrent-time');
           if(el)
              el.textContent = Utils.getExactDuationInSeconds(this.player.currentTime() , this.frameRate, '.');
        },
        attachCurrentTimeUpdateHandler(){
           this.player.on('timeupdate',this.updatePlayerCurrentTime);
        },
        getCurrentPlayerTime(){
            return this.player.currentTime();
        },
        handleVolumeChange(){
           if(this.player.muted()){
               localStorage.setItem('fusion:isPlayerMuted',true);
           }else{
              localStorage.setItem('fusion:playerVolume',String(this.player.volume()));
              localStorage.setItem('fusion:isPlayerMuted',false);
           }
        },
        onPlayerReady(){
            this.$emit("controller",this.controller)
        },
        startPlayer(){
            Object.assign(this.options,{preload: "metadata"});
            let isStreamablePlayer = false;
            try{
                if(this.options && this.options.sources && Array.isArray(this.options.sources) && this.options.sources[0] && 'src' in this.options.sources[0] && String(this.options.sources[0].src).endsWith('m3u8')){
                    Object.assign(this.options,{liveui:true, autoplay: true, html5: { hls: { overrideNative: true }, nativeAudioTracks: false, nativeVideoTracks: false }});
                    this.options.sources[0]['type'] = "application/x-mpegURL";
                    isStreamablePlayer = true;
                }
            }catch(e){console.log(e)}
            console.log(isStreamablePlayer);
            this.player = videojs(this.$refs.videoPlayer, this.options, this.onPlayerReady);
            // this.player.plugin('markers',videojsMarkersPlugin);
            if(localStorage.getItem('fusion:playerVolume') != null){
                let v = Number(localStorage.getItem('fusion:playerVolume'));
                if(!isNaN(v)) this.player.volume(v);
            }
            if(localStorage.getItem('fusion:isPlayerMuted') != null){
                let ismuted = JSON.parse(localStorage.getItem('fusion:isPlayerMuted'));
                if(typeof ismuted == 'boolean')
                   this.player.muted(ismuted);
            }
            this.controller = {"restartPlayer": this.restartPlayer, player: this.player}
            if(isStreamablePlayer){ // for live stream first frame ready
                 this.player.off('loadeddata');
                 this.player.on("loadeddata", () => {
                     this.$emit('metaDataLoaded',-1);
                        // Check if it's a live stream and if it needs loading
                        const isLive = this.player.duration() === Infinity;
                        const readyState = this.player.readyState();

                        console.log("readyState readyState",readyState, 'isLive =====',isLive);
                        
                 });
            }
            this.player.off('loadedmetadata');
            this.player.on('loadedmetadata',() =>{
            try{
                this.player.pause()
            }catch(e){console.log(e)}
                this.$root.$emit('player-duration',this.player.duration());
                this.$emit('metaDataLoaded',this.player.duration());
                if(this.isCurrentTimeUpdateRequired){
                    this.attachCurrentTimeUpdateHandler();
                }
            });

            this.player.off('error');
            this.player.on('error', () => {
                const err = this.player.error();
                try {
                    this.player.pause();
                } catch(e) { console.log(e); }
                this.$emit('playerError', err);
            });


            this.player.on('volumechange',this.handleVolumeChange);

            try{
                if(this.$parent.$refs.minimizedplayerMainWrapper){
                    this.setActiveMiniPlayer(this.$parent);
                }
            }catch(e){console.log(e)}
        },
        restartPlayer(source,callback){
            try{
                source = Utils.convertToLoginIPDomainName(source);
            }catch(e){console.log(e)}
            if (this.player) {
                this.player.src(source)
                this.player.play()
            }
            // this.startPlayer()
            // if(callback && typeof callback === 'function'){
              this.player.off('loadedmetadata');
              this.player.on('loadedmetadata',() =>{
                     this.$emit('metaDataLoaded');
                     if(callback && typeof callback === 'function'){
                        callback(this.player.duration());
                      }
              });
            // }
                
        },

        ...mapMutations("player",["setActiveMiniPlayer"]),
        ...mapGetters("player",["getActiveMiniPlayer"])
    },
    mounted() {
        this.startPlayer();
    },
    beforeDestroy() {
        if (this.player) {
            try {
                this.player.dispose()    
            } catch (error) {
                console.error(`[beforeDestroy][VideoPlayer][Error while disposing player->${error}]`)
                if (videojs.getPlayer("videoJSPlayer")) {
                    videojs("videoJSPlayer").dispose();
                }
            }
        }
        this.player.off('volumechange',this.handleVolumeChange);
        this.setActiveMiniPlayer(null);
         try{
             this.player.off('timeupdate',this.updatePlayerCurrentTime);
         }catch(e){
            console.error(`[error][timeupdate][callback] unable to detatch`);
         }
    },

    computed:{
        getPlayerProgressbarClass(){
            if(this.isProgressbarRequired){
                return 'show-progress-bar-always';
            }
            return '';
        }
    },

   created(){
       try{
            if(this.getActiveMiniPlayer()){
                this.getActiveMiniPlayer().$emit("closeMiniPlayer");
            }
        }catch(e){console.log(e)}

         try{
             this.player.off('timeupdate',this.updatePlayerCurrentTime);
         }catch(e){
            console.error(`[error][timeupdate][callback] unable to detatch`);
         }
   }
}
</script>

<style scoped lang="scss">
   $text-color: #eee;
   $dull-text-color: #757575;


   .video-js.vjs-fullscreen{
    .vjs-tech{
        width:100% !important;
    }
   }
  
  ::v-deep{
   .player-current-time-division{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        letter-spacing: 1px;
        font-weight: 400;
        font-size: 12px;
        font-family: Roboto,Arial,sans-serif!important;
        .currrent-time{
            color: $text-color;
            min-width: 60px;
        }
        .time-division-label{
            margin-inline-start: 5px;
            margin-inline-end: 5px;
            color: #a9a9a9;
        }
        .full-time-of-time-division{
            color: #a9a9a9;
            min-width: 60px;
        }
    }

    .show-progress-bar-always .vjs-control-bar{
        display: flex !important;
        opacity:1 !important;
    }
  }

.show-progress-bar-always .vjs-control-bar{
    display: flex !important;
    opacity:1 !important;
 }

</style>



